export const compareConnectConstants = {
  SEO: {
    title: 'Compare & Connect',
    description: 'Compare & Connect',
  },
};
